module.exports = __webpack_public_path__ + "static/snake_ao-07755b2ed4d298d24bb3c8097205420a.png";